import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const StripeIcon = forwardRef<SVGSVGElement, Props>(
	({ className, ...props }, ref) => {
		return (
			<svg
				xmlns="http://www.w3.org/2000/svg"
				viewBox="0 0 32 32"
				ref={ref}
				{...props}
				className={className}
			>
				<path
					fill="#635BFF"
					d="M32 16.5c0 9.113-7.387 16.5-16.5 16.5S-1 25.613-1 16.5 6.387 0 15.5 0 32 7.387 32 16.5Z"
					transform="translate(0.5)"
				/>
				<path
					fill="#fff"
					fillRule="evenodd"
					d="M14.97 12.873c0-.873.717-1.21 1.904-1.21 1.703 0 3.852.515 5.555 1.434V7.853c-1.858-.738-3.696-1.03-5.555-1.03-4.529 0-7.541 2.366-7.541 6.318 0 6.165 8.485 5.18 8.485 7.835 0 1.031-.897 1.367-2.15 1.367-1.857 0-4.235-.762-6.116-1.793v5.31c2.082.896 4.187 1.276 6.117 1.276 4.64 0 7.832-2.293 7.832-6.296-.022-6.65-8.531-5.467-8.531-7.967Z"
					clipRule="evenodd"
				/>
			</svg>
		)
	},
)
